import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/index.vue";

Vue.use(VueRouter);

// 保存原有的 push 方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err; // 其他错误抛出
    }
  });
};

// 保存原有的 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err; // 其他错误抛出
    }
  });
};

const routes = [
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/404",
        component: () => import("@/views/404/index.vue"),
        name: "404",
        meta: {
          hideBreadcrumb: true,
        }
      },
      {
        path: "/",
        component: () => import("@/views/home/index.vue"),
        name: "home",
        meta: {
          hideBreadcrumb: true,
        }
      },
      {
        path: "/project",
        component: () => import("@/views/project/index.vue"),
        name: "project",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/project/list.vue"),
            name: "projectList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/project/detail.vue"),
            name: "projectDetail",
          },
          {
            path: "preview/:code",
            component: () => import("@/views/project/preview.vue"),
            name: "projectPreview",
            meta: {
              hideNav: true,
              hideBreadcrumb: true,
              hideHeader: true,
              hideFooter: true,
            },
          },
        ],
      },
      {
        path: "/qyzc",
        component: () => import("@/views/qyzc/index.vue"),
        name: "qyzc",
        children: [
          {
            path: "list",
            component: () => import("@/views/qyzc/list.vue"),
            name: "qyzcList",
            meta: {
              showBanner: true,
            }
          },
          {
            path: "detail/:code",
            component: () => import("@/views/qyzc/detail.vue"),
            name: "qyzcDetail",
            meta: {
              showBanner: true,
            }
          },
        ],
      },
      {
        path: "/gwczl",
        component: () => import("@/views/gwczl/index.vue"),
        name: "gwczl",
        meta: {
          showBanner: true,
        }
      },
      {
        path: "/nbtp",
        component: () => import("@/views/nbtp/index.vue"),
        name: "nbtp",
        meta: {
          showBanner: true,
        }
      },
      {
        path: "/news",
        component: () => import("@/views/news/index.vue"),
        name: "news",
        children: [
          {
            path: "list",
            component: () => import("@/views/news/list.vue"),
            name: "newsList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/news/detail.vue"),
            name: "newsDetail",
          },
        ],
      },
      {
        path: "/info",
        component: () => import("@/views/info/index.vue"),
        name: "info",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/info/list.vue"),
            name: "infoList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/info/detail.vue"),
            name: "infoDetail",
          },
          {
            path: ":code",
            component: () => import("@/views/info/_code.vue"),
            name: "codeDetail",
          },
        ],
      },
      {
        path: "/search",
        component: () => import("@/views/search/index.vue"),
        name: "search",
        meta: {
          hideNav: true,
          hideBreadcrumb: true,
          hideHeader: true,
          hideFooter: true,
        },
      },
    ],
  },
  {
    path: "/print",
    component: () => import("@/views/print/index.vue"),
    name: "print",
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  base: "/web/",
  routes,
});

export default router;
